"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeSpecifiedContractCallTransaction = exports.decodeContractCallTransaction = void 0;
const transactions_1 = require("@stacks/transactions");
function decodeContractCallTransaction(contracts, tx) {
    if (!(tx.contract_call.contract_id in contracts)) {
        throw new Error(`[decodeContractCallTransaction] unknown contract id ${tx.contract_call.contract_id}`);
    }
    const contractName = tx.contract_call.contract_id;
    if (!(tx.contract_call.function_name in contracts[contractName])) {
        throw new Error(`[decodeContractCallTransaction] unknown function name ${contractName}.${tx.contract_call.function_name}`);
    }
    const functionName = tx.contract_call
        .function_name;
    return Object.assign({ contractName,
        functionName }, decodeSpecifiedContractCallTransaction(contracts, contractName, functionName, tx));
}
exports.decodeContractCallTransaction = decodeContractCallTransaction;
function decodeSpecifiedContractCallTransaction(contracts, contractOrType, functionName, tx) {
    const functionDescriptor = contracts[contractOrType][functionName];
    const args = functionDescriptor.input.reduce((acc, arg, index) => (Object.assign(Object.assign({}, acc), { [arg.name]: arg.type.decode((0, transactions_1.deserializeCV)(tx.contract_call.function_args[index].hex)) })), {});
    const result = functionDescriptor.output.decode((0, transactions_1.deserializeCV)(tx.tx_result.hex));
    return { args: args, result, raw: tx };
}
exports.decodeSpecifiedContractCallTransaction = decodeSpecifiedContractCallTransaction;
